// src/components/layout/Topbar.tsx
import React from "react";
import { Icon } from "@iconify/react";
import { useLocation } from "react-router-dom";
import NotificationBell from "../NotificationBell";

type Props = {
  onOpenMobile?: () => void;
  compact?: boolean;
  onToggleCompact?: () => void;
  isMobileView?: boolean;
  className?: string;
};

const Topbar: React.FC<Props> = ({ onOpenMobile, compact, onToggleCompact, isMobileView, className = "" }) => {
   const location = useLocation();

  // Map route paths to display names
  const routeTitleMap: Record<string, string> = {
    "/": "Dashboard",
    "/employees": "Employees",
    "/employees/details": "Employees",
    "/customers": "Customers",
    "/customers/details": "Customers",        
    "/vehicles": "Vehicles",
    "/loans": "Loans",
    "/transactions":"Transaction"
  };

  // Extract the path
  const currentPath = location.pathname;

  // Get title based on route, fallback if not found
  const pageTitle = routeTitleMap[currentPath] || "Welcome";
  return (
    <header className={`flex items-center justify-between gap-4  bg-white shadow-md rounded-xl p-2 border-b-3 border-[#C6DBFF] ${className}`}>
      <div className="flex items-center gap-4">
        {/* Mobile/tablet hamburger */}
        {isMobileView && (
          <button
            onClick={onOpenMobile}
            className="p-2 rounded-md hover:bg-gray-100"
            aria-label="Open menu"
          >
            <Icon icon="mdi:menu" width="22" />
          </button>
        )}

        <div className="md:pl-3">
          <h2 className="text-2xl font-semibold text-[#00aef0]">{pageTitle},</h2>
          <p className="text-xs text-gray-500">Let's check your states today!</p>
        </div>
      </div>

      <div className="flex items-center gap-3">
        {/* <button className="p-2  md:mr-3 rounded-full hover:bg-blue-100 bg-blue-200 text-blue-700 cursor-pointer">
          <Icon icon="f7:bell" width="20" />
        </button> */}
        <NotificationBell />

      </div>
    </header>
  );
};

export default Topbar;
